import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=3d6ebf32&scoped=true&"
import script from "./PriceList.vue?vue&type=script&lang=js&"
export * from "./PriceList.vue?vue&type=script&lang=js&"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=3d6ebf32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6ebf32",
  null
  
)

export default component.exports